export default __webpack_public_path__ + "static/media/icon-lattice.a9d78baf.svg";